import React, { useCallback } from 'react';
import { PrimaryButton, SecondaryButton } from '@kallidus/common';
import { useTranslation } from 'react-i18next';
import { SAPLING_PRODUCT_INFO_URL } from '@ApplicationWide/constants/external_urls';

const useContactUsButtons = () => {
  const { t } = useTranslation();
  return useCallback(
    (disabled, formState, formApi, onClose, formId) => (
      <>
        <PrimaryButton type='submit' form={formId} disabled={disabled} loading={formState?.submitting}>
          {t('std-button.send')}
        </PrimaryButton>
        <SecondaryButton href={SAPLING_PRODUCT_INFO_URL} target='_blank'>
          {t('pay-wall.contact-us-modal.explore-plans-cta')}
        </SecondaryButton>
      </>
    ),
    [t],
  );
};

export default useContactUsButtons;
